import { render, staticRenderFns } from "./SidemenuIcon.vue?vue&type=template&id=c8e4962a&scoped=true&"
import script from "./SidemenuIcon.vue?vue&type=script&lang=js&"
export * from "./SidemenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./SidemenuIcon.vue?vue&type=style&index=0&id=c8e4962a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e4962a",
  null
  
)

export default component.exports